var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    [
      _vm.showLoader
        ? _c("component-loader", {
            attrs: { progress: 90, unlimitedProgress: true, activeClose: true },
            on: {
              close: function ($event) {
                _vm.showLoader = false
              },
            },
          })
        : _vm._e(),
      _c("div", { staticClass: "subtitle" }, [
        _c("p", [
          _vm._v("\n            " + _vm._s(_vm.$t("dash.pages.overlay.last"))),
          _c("br"),
          _vm._v(
            "\n            " +
              _vm._s(
                _vm.$t(
                  `dash.pages.overlay.select_${
                    ["facebook", "instagram", "google", "linkedin"].includes(
                      this.network
                    )
                      ? this.network
                      : "default"
                  }`
                )
              ) +
              "\n        "
          ),
        ]),
      ]),
      this.network == "linkedin"
        ? _c("div", { staticClass: "warning" }, [
            _vm._v(
              "\n      " +
                _vm._s(_vm.$t("dash.pages.linkedin.warning")) +
                "\n    "
            ),
          ])
        : _vm._e(),
      _c(
        "div",
        { staticClass: "search-page" },
        [
          _c(
            "div",
            { staticClass: "select-all", on: { click: _vm.selectAll } },
            [_vm._v(_vm._s(_vm.$t("dash.pages-sidebar.cta-select-all")))]
          ),
          _c(
            "div",
            { staticClass: "unselect-all", on: { click: _vm.unselectAll } },
            [_vm._v(_vm._s(_vm.$t("dash.pages-sidebar.cta-unselect-all")))]
          ),
          _c("vs-input", {
            staticClass: "inputx",
            class: { input: true },
            attrs: {
              color: "#B20564",
              "icon-after": "true",
              icon: "search",
              placeholder: _vm.$t("dash.settings.user.label.page_filter"),
            },
            model: {
              value: _vm.pageFilter,
              callback: function ($$v) {
                _vm.pageFilter = $$v
              },
              expression: "pageFilter",
            },
          }),
        ],
        1
      ),
      _c("div", { staticClass: "connected-pages" }, [
        _c(
          "div",
          { staticClass: "linked-pages" },
          _vm._l(_vm.showLinked, function (item) {
            return _c(
              "div",
              {
                key: item.id,
                staticClass: "page",
                on: {
                  click: function ($event) {
                    return _vm.alertUnlink(item)
                  },
                },
              },
              [
                _c("div", { staticClass: "page-wrapper" }, [
                  _c(
                    "div",
                    { staticClass: "page-content" },
                    [
                      _c("vs-avatar", {
                        staticClass: "page-img",
                        attrs: { size: "33px", src: item.avatar, alt: "page" },
                      }),
                      _c("p", { staticClass: "page-name" }, [
                        _vm._v(_vm._s(item.name)),
                      ]),
                      _c("p", { staticClass: "page-type" }, [
                        _vm._v(_vm._s(item.type)),
                      ]),
                      _vm._m(0, true),
                    ],
                    1
                  ),
                ]),
              ]
            )
          }),
          0
        ),
        _c("hr"),
        _c("div", { staticClass: "subtitle" }, [
          _c("p", [
            _vm._v(
              "\n                " +
                _vm._s(_vm.$t("dash.pages.overlay.unlinked")) +
                "\n            "
            ),
          ]),
        ]),
        _c(
          "div",
          { staticClass: "unlinked-pages" },
          _vm._l(_vm.showUnlinked, function (item) {
            return _c(
              "div",
              {
                key: item.id,
                staticClass: "page",
                on: {
                  click: function ($event) {
                    return _vm.add(item)
                  },
                },
              },
              [
                _c("div", { staticClass: "page-wrapper" }, [
                  _c(
                    "div",
                    { staticClass: "page-content" },
                    [
                      _c("vs-avatar", {
                        staticClass: "page-img",
                        attrs: { size: "33px", src: item.avatar, alt: "page" },
                      }),
                      _c("p", { staticClass: "page-name" }, [
                        _vm._v(_vm._s(item.name)),
                      ]),
                      _c("p", { staticClass: "page-type" }, [
                        _vm._v(_vm._s(item.type)),
                      ]),
                    ],
                    1
                  ),
                ]),
              ]
            )
          }),
          0
        ),
      ]),
      _c(
        "div",
        { staticClass: "button-wrapper" },
        [
          _c(
            "vs-button",
            {
              staticClass: "page-btn btn-large",
              attrs: { "vs-type": "filled" },
              on: { click: _vm.validate },
            },
            [
              _vm._v(
                "\n            " +
                  _vm._s(_vm.$t("dash.pages.overlay.validate")) +
                  "\n        "
              ),
            ]
          ),
        ],
        1
      ),
      _c(
        "vs-popup",
        {
          staticClass: "overlay",
          attrs: { title: _vm.dialog.title, active: _vm.dialog.show },
          on: {
            "update:active": function ($event) {
              return _vm.$set(_vm.dialog, "show", $event)
            },
          },
        },
        [_c("p", [_vm._v(_vm._s(_vm.dialog.message))])]
      ),
      _c("div", { staticClass: "close-btn", on: { click: _vm.cancel } }, [
        _c("i", { staticClass: "material-icons" }, [_vm._v("close")]),
      ]),
    ],
    1
  )
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "checkmark" }, [
      _c("i", { staticClass: "material-icons" }, [_vm._v("check")]),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }